module.exports = __webpack_public_path__ + "img/departement06.af31a7e2.png";